import { PagedSearch } from 'src/app/shared';

export class CouponSearchDto extends PagedSearch {
  Approved: boolean;
  ProfileName: string;
  SubmittedDateRangeStart: Date;
  SubmittedDateRangeEnd: Date;
  IncludeMemberCouponsOnly: boolean;
}
